import React from "react";
import "./navbar.css";
import NavbarItems from "./navbarItems";
import { Link as RouterLink } from "react-router-dom";
import { Image, Link } from "@chakra-ui/react";
import logo from "../images/hypospadiaslogo.png";
import { useAuthContext } from "../auth-check/authContext";
import { useHomepageContext } from "../home/homepageContext";

export default function Navbar(props) {
  const { activeSection } = useHomepageContext();
  const { isAuthed } = useAuthContext();
  const x = isAuthed
    ? {
        title: "Dashboard",
        url: "/dashboard",
        cname: "nav-links-signup",
        isLink: true,
      }
    : {
        title: "Sign Up",
        url: "/signup",
        cname: "nav-links-signup",
        isLink: true,
      };
  return (
    <>
      <nav className='NavbarItems'>
        <div>
          <Link as={RouterLink} to='/' _focus={{ textDecoration: "none" }}>
            <Image src={logo} className='navbar-logo' />
          </Link>
        </div>

        <div
          className='menu-icon'
          onClick={() => props.setIsMenuOpen(!props.isMenuOpen)}
        >
          <i className={props.isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
        </div>
        <ul className={props.isMenuOpen ? "nav-menu active" : "nav-menu"}>
          {NavbarItems.concat(x).map((item, index) => {
            if (item.isLink)
              return (
                <li key={index}>
                  <Link
                    _active={{
                      borderBottom: "1px solid #333333",
                    }}
                    className={item.cname}
                    to={item.url}
                    onClick={() => props.setIsMenuOpen(false)}
                    as={RouterLink}
                    _focus={{ textDecoration: "none" }}
                    _hover={{ textDecoration: "none" }}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            else
              return (
                <li key={index}>
                  <a
                    data-hash={item.hash}
                    className={`${item.cname} ${
                      item.hash === `#${activeSection}` ? "is-active" : ""
                    }`}
                    href={item.url}
                    onClick={() => props.setIsMenuOpen(false)}
                  >
                    {item.title}
                  </a>
                </li>
              );
          })}
        </ul>
      </nav>
    </>
  );
}
